import { CenteredFlexBox } from '../layout';
import { Box, styled } from '@mui/material';

export const MonthHeader = styled(CenteredFlexBox)(({ theme }) => ({
  position: 'relative',
  marginBottom: theme.spacing(4),
}));

export const WeekdayContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(7,1fr)',
  textAlign: 'center',
  borderBottom: `1px solid ${theme.customColors.neutral300}`,
  marginLeft: theme.spacing(4),
  marginBottom: theme.spacing(1),
}));

export const DateCellContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(7,1fr)',
  gridAutoRows: 32,
  gap: theme.spacing(0.5),
  marginLeft: theme.spacing(4),
}));

export const DateCell = styled(CenteredFlexBox)(({ theme }) => ({
  cursor: 'pointer',
  borderRadius: theme.spacing(1),
}));
